import Home from './pag/Home.svelte';
import Login from './pag/Login.svelte';
import Gue from './pag/Gue.svelte';
import Con from './pag/Con.svelte';
// import Pag from './pag/Pag.svelte';
// import from './pag/.svelte';

import Notfound from './pag/Notfound.svelte';

// Export the route definition object
export default {
    '/home': Home,
    '/login': Login,
    '/gue': Gue,
    '/con': Con,
    // '/pag': Pag,

    // Catch-all, must be last
    '*': Notfound,
};
